import styled from 'styled-components';
import { TrevorIcon } from '../TrevorIcon';
import { Subtitle } from '../TypographyNew';

export const TestimonialCardContainer = styled.div`
  padding: var(--spacing-l);
  background: #ffffff;
  border-radius: var(--radius-16);
  width: 256px;
  filter: drop-shadow(0px 1px 2px rgba(28, 28, 33, 0.3));
  color: var(--color-interface-content-normal);
  position: relative;
`;

export const TestimonialHeader = styled.div`
  margin-bottom: var(--spacing-l);
  display: flex;
  gap: var(--spacing-l);
`;

export const TestimonialImage = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;
`;

export const TestimonialName = styled(Subtitle).attrs({
  variant: 1,
})`
  font-weight: 700;
`;

export const TestimonialDetails = styled.div`
  display: flex;
  flex-direction: column;
  width: 126px;
`;

export const TestimonialTip = styled(TrevorIcon).attrs({
  name: 'testimonial-tip',
})`
  position: absolute;
  bottom: 0;
  right: 0;
`;
